module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av308-89d71d7e3fe292a3777480ce8f68d93a.jpg";